/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/CaseLink.js
 */

import React from 'react';
import { Link } from 'react-router-dom';

const getLink = (data) => `/search?query=${data.customer.id}&case=${data.id}`;

const CaseLink = ({ data, type }) => {
  const productsToBeCancelled = [];
  for (var product in data.products) {
    if (data.products[product]) {
      productsToBeCancelled.push(product.slice(6));
    }
  }
  const productsToBeCancelledString = productsToBeCancelled.toString();
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <Link className="Link" to={getLink(data)}>
          <div className="Type">Customer</div>
          <div className="Value">{data.customer.name}</div>
        </Link>
      </div>
      <div className="SummaryLink">
        <Link className="Link" to={getLink(data)}>
          {getLink(data)}
        </Link>
      </div>
      <div className="SummaryData">
        <p>Case number: {data.caseNumber}</p>
        <p>
          {data.cancelAllProducts
            ? `Full cancel`
            : productsToBeCancelled.length > 0
            ? `Products to be cancelled: ${productsToBeCancelledString}`
            : ''}
        </p>
        <p>Cancellation notice date: {data.cancelNotifyDate}</p>
        <p>Service end date: {data.serviceEndDate}</p>
      </div>
    </div>
  );
};

export default CaseLink;
